"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function array2object(inp) {
    const ans = {};
    if (Array.isArray(inp)) {
        inp.forEach(item => {
            if (item && item.id)
                ans[item.id] = item;
        });
    }
    return ans;
}
exports.default = array2object;
//# sourceMappingURL=array2object.js.map